import { setLocalStore, getLocalStore } from "./localStoreSrv";
//import { useDispatch, useSelector } from "react-redux";
const getAccessToken = () => {
    const authSession = getLocalStore('PAS');
    console.log(authSession);
    return authSession.access_token ? authSession.access_token : null;
}
const setAccessToken = (token: string) => {
    setLocalStore('API_ACCESS_TOKEN', token)
}
export { getAccessToken, setAccessToken }